import { useTranslation } from "react-i18next";
import { GenericError } from "./GenericError.tsx";

export interface Error500InternalServerErrorProps {
  onClose?: () => void;
}

export const Error500InternalServerError = ({ onClose }: Error500InternalServerErrorProps) => {
  const { t } = useTranslation("common");

  return (
    <GenericError
      errorNumber={500}
      title={t("errors.httperror500")}
      description={t("errors.httperror500detail")}
      onClose={onClose}
    />
  );
};
